const Lang = require('lang');
const GlobalAlerts = require('./GlobalAlerts');

import Gmaps from '../classes/Gmaps';

let firstToggle = true;

function AlternarMapaImagem() {
  $(document).on('click', '.change-between-map-image', event => {
    const attachmentPanel = $('.route-attachment-panel');
    const imagePanel = $('.image-panel');
    const mapPanel = $('.map-panel');
    const data = event.currentTarget.dataset;

    if (firstToggle) {
      getPanel(data.idDespesa)
        .done(
          function (response) {
            imagePanel.hide();
            attachmentPanel.append(response);
            Gmaps.init();
            firstToggle = false
          }
        ).fail(
          function (e) {
            GlobalAlerts.createAndShow({
              type: 'danger',
              title: Lang.get('js/common/phrases.ops'),
              message: e.responseJSON.message
            });
          }
        );
    } else if (!firstToggle && data.toggle === 'mapa') {
      imagePanel.hide();
      mapPanel.show();
    } else {
      mapPanel.hide();
      imagePanel.show();
    }
  });
}

/**
 * requisição para obter o painel do mapa interativo
 *
 * @param  {int} idDespesa
 *
 * @return {$.ajax}
 */
function getPanel(idDespesa) {
  return $.ajax({
    method: 'GET',
    url: route('app.despesas.buscar-mapa-do-percurso', idDespesa)
  });
}

module.exports = {
  init: AlternarMapaImagem,
  url: /\/despesas\/\d+/
};
